import { Action } from "redux";

import { INotification, NotificationLevel } from "./notification";

export enum NotificationActionType {
    PUSH = "@@error/PUSH",
    REMOVE = "@@error/REMOVE"
}

export type INotificationAction = IPushNotificationAction | IRemoveNotificationAction;

export interface IPushNotificationAction extends Action<NotificationActionType.PUSH> {
    notification: INotification;
    autoRemove: false | number;
}

export type IRemoveNotificationAction = Action<NotificationActionType.REMOVE> & Pick<INotification, "timeStamp">;

export function pushNotification(
    message: string,
    notificationLevel: NotificationLevel,
    autoRemove: IPushNotificationAction["autoRemove"] = 5000,
): IPushNotificationAction {
    return {
        type: NotificationActionType.PUSH,
        notification: { message, notificationLevel, timeStamp: new Date().toISOString() },
        autoRemove,
    };
}

export function removeNotification(timeStamp: string): IRemoveNotificationAction {
    return {
        type: NotificationActionType.REMOVE,
        timeStamp,
    };
}
